// extracted by mini-css-extract-plugin
export default {"bottomSlogan":"BottomSlogan_bottomSlogan__-T-J8"};